var React = require('react');

function PracticeGreen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.25 18C16.9404 18 17.5 17.4404 17.5 16.75C17.5 16.0596 16.9404 15.5 16.25 15.5C15.5596 15.5 15 16.0596 15 16.75C15 17.4404 15.5596 18 16.25 18Z","fill":"#616466","key":0}),React.createElement("path",{"d":"M14.1663 5.43341L7.49967 2.16675V17.1667H5.83301V15.7251C4.34134 16.0167 3.33301 16.5501 3.33301 17.1667C3.33301 18.0834 5.57467 18.8334 8.33301 18.8334C11.0913 18.8334 13.333 18.0834 13.333 17.1667C13.333 16.3417 11.533 15.6584 9.16634 15.5251V7.98341L14.1663 5.43341Z","fill":"#616466","key":1})]);
}

PracticeGreen.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = PracticeGreen;

PracticeGreen.default = PracticeGreen;
